import React, { FC } from 'react';
import classNames from 'classnames';

import Link from '../../Controls/Link';

import css from './style.module.scss';
import setQaAttribute from '../../../helpers/setQaAttribute';

interface ITab {
  text: string;
  link: string;
  isActive?: boolean;
}

interface IProps {
  tabs: ITab[];
  qaId?: string;
}

const NavTabs: FC<IProps> = ({ tabs, qaId }) => {
  return (
    <div className={css.navTabs} {...setQaAttribute(qaId)}>
      {tabs.map((tab) => (
        <Link
          textDecoration="none"
          to={tab.link}
          className={classNames(css.navTabs__link, { [css.active]: tab.isActive })}
          key={tab.text}
        >
          {tab.text}
        </Link>
      ))}
    </div>
  );
};

export default NavTabs;
